import { API } from '@Providers';

export default async function (rowsPerPage: number, mainRequestUrlParams: any) {
  const endpoint = `/api/shelter/products/get-product-list?per_page=${rowsPerPage}${mainRequestUrlParams}`;

  return API({ endpoint });
}
